import * as React from "react";
import { IMedicinePrescription } from "@curefit/ehr-common";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import {PatientCurrentMedicationEditorProps} from "../../components/patient/edit/PatientCurrentMedicationEditor";
import {SourceConstants} from "../../utils/AppConstants";
import IMedicineType from "../../models/staticData/IMedicineType";
import {MedicinePrescriptionViewProps} from "../../components/prescription/medicine/MedicinePrescriptionView";
import ErrorContainer from "./../ErrorContainer"
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";

/**
 * Created by abhinav on 28/01/18.
 */

export interface CurrentMedicationEditViewContProps {
    appointmentId?: number,
    consultationType?: string,
    titleToDisplay?: string,
    medicationType?: string,
    patientId: number,
    patientMedication: IMedicinePrescription[],
    activeMedication?: IMedicinePrescription[],
    staticMedicineTypes: IMedicineType[],
    fetchPatientMedication?: (patientId: number) => any,
    savePatientMedication?: (patientId: number, patientCurrentMedication: IMedicinePrescription[]) => any,
    displayMode?: EditViewDisplayMode,
    questionnaire?: ITypeFormQuestionnaire[],
    typeFormMapping?: any
}

export interface CurrentMedicationEditViewContState {
    updatedMedication: {item: IMedicinePrescription}[],
    isPatientMedicationDataLoaded: LOADING_STATE,
    error: string,
    errorDetails: string
}

class CurrentMedicationEditViewCont extends React.Component<CurrentMedicationEditViewContProps, CurrentMedicationEditViewContState> {

    constructor(props: CurrentMedicationEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: CurrentMedicationEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedMedicationFromProps = (props: CurrentMedicationEditViewContProps): {item: IMedicinePrescription}[] => {
        let currUpdatedMedication: {item: IMedicinePrescription}[] = [];
        _.map(props.patientMedication, function(patientMedication){
            let clonePatientMedication = Object.assign({}, patientMedication);
            currUpdatedMedication.push({item: clonePatientMedication});
        });
        return currUpdatedMedication;
    }

    getStateFromProps = (props: CurrentMedicationEditViewContProps) => {
        let currState: CurrentMedicationEditViewContState = {
            updatedMedication: [],
            isPatientMedicationDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            error: "",
            errorDetails: ""
        }
        if ( _.isNull(props.patientMedication) ) {
            props.fetchPatientMedication(this.props.patientId);
            currState.isPatientMedicationDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedMedication = [];
            _.map(props.patientMedication, function(patientMedication){
                let clonePatientMedication = Object.assign({}, patientMedication);
                currState.updatedMedication.push({item: clonePatientMedication});
            });
            currState.isPatientMedicationDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getCurrentMedicationEditViewTemplateProps = () => {
        let patientMedicationViewProps: MedicinePrescriptionViewProps = {
            medicinePrescriptionList: this.props.patientMedication,
            staticMedicineTypes: this.props.staticMedicineTypes
        }
        let patientMedicationEditorProps: PatientCurrentMedicationEditorProps = {
            consultationType: this.props.consultationType,
            medicationType: this.props.medicationType,
            updatedCurrentMedication: this.state.updatedMedication,
            updateCurrentMedication: this.updateCurrentMedication,
            staticMedicineTypes: this.props.staticMedicineTypes,
            activeMedication: this.props.activeMedication
        }
        return {"view": patientMedicationViewProps, "edit": patientMedicationEditorProps};
    }

    updateCurrentMedication = (updatedCurrentMedication: {item: IMedicinePrescription}[]) => {
        this.setState({updatedMedication: updatedCurrentMedication});
    }

    saveCurrentMedication = () => {
        let myInstance = this;
        let saveMedicationList: IMedicinePrescription[] = this.getSaveObject();
        // if (saveMedicationList.length > 0) {
        if (this.isFormDirty()) {
            this.setState({
                error: "Cannot save Medication",
                errorDetails: "Please fill in all the mandatory fields before proceeding"
            })
        } else {
            this.setState({isPatientMedicationDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientMedication(this.props.patientId, saveMedicationList).then(function() {
                myInstance.setState({isPatientMedicationDataLoaded: LOADING_STATE.LOADED})
            });
        }
        // }
    }

    cancelActionHandler = () => {
        this.setState({updatedMedication: this.getUpdatedMedicationFromProps(this.props)});
    }

    getSaveObject = (): IMedicinePrescription[] => {
        let myInstance = this;
        let saveMedicationList: IMedicinePrescription[] = [];
        let patientId = this.props.patientId;
        let medicationType = this.props.medicationType;
        _.map(myInstance.state.updatedMedication, function(updatedCurrentMedicationItem: {item: IMedicinePrescription}, index){
            // if (ModelFactory.isValidMedication(updatedCurrentMedicationItem.item)) {
                let medication = AppUtils.sanitizeRequestItemBeforeSave(updatedCurrentMedicationItem.item);
                medication.slotList = AppUtils.arrangeDosageArray(medication.slotList);
                medication.inputSource = medicationType;
                medication.source = SourceConstants.DOCSASPP;
                medication.patientId = patientId;
                medication.appointmentId = myInstance.props.appointmentId;
                medication.isDeleted = false;
                if (medication.id !== undefined) delete medication.id;
                saveMedicationList.push(medication);
            // }
        });
        return saveMedicationList;
    }

    isFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedMedication, function(updatedMedicationItem: {item: IMedicinePrescription}){
            if (!ModelFactory.isValidMedication(updatedMedicationItem.item)) {
                status = true;
                return false;
            }
        })
        return status;
    }

    clearErrorMessage = () => {
        this.setState({
            error: "",
            errorDetails: ""
        })
    }

    render() {
        let isMedicationDataLoaded =  this.state.isPatientMedicationDataLoaded === LOADING_STATE.LOADED;
        let titleToDisplay = !_.isEmpty(this.props.titleToDisplay) ? this.props.titleToDisplay : "Current Medication";
        let errorMessage = !_.isEmpty(this.state.error) ? this.state.error : null;
        let errorDetails = !_.isEmpty(this.state.errorDetails) ? this.state.errorDetails : "";
        return (
            <div className="allergy-editview-cont">
                {
                    !_.isNull(errorMessage) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}/>
                }
                {
                    isMedicationDataLoaded &&
                    <EditViewCard cardTitleDisplay={titleToDisplay} templateName={"currentMedication"}
                                  templateProps={this.getCurrentMedicationEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveCurrentMedication}
                                  cancelActionHandler={this.cancelActionHandler} displayMode={this.props.displayMode} />
                }
                {
                    !isMedicationDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default CurrentMedicationEditViewCont